import React = require('react');
import { flow, get } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { mtaActions } from '../../../../services/mta/actions';
import { IMtaActions } from '../../../../services/mta/models';
import { IAuthState } from '../../../../services/auth/models';
import { OfferCardPanel } from './OfferCardPanel';
import { PartnerOfferCard } from './PartnerOfferCard';
import { AdmiralOfferCard } from './AdmiralOfferCard';
import { FaMoneyBillWave, FaStar } from 'react-icons/fa';
import { AdmiralHouseholdOfferCard } from './AdmiralHouseholdOfferCard';

interface ICustomerOffersProps {
  auth: IAuthState;
  actions: {
    auth: IAuthActions;
    mta: IMtaActions;
  };
}

class CustomerOffers extends React.Component<ICustomerOffersProps, any> {

  public state = {
    showBanner: false,
    policyId: undefined,
    customerName: undefined,
  };

  constructor(props) {
    super(props);
  }

  public componentDidMount(): void {
    const { actions, auth } = this.props;
    const mtaOptions = actions.mta.getCustomerMtaOptions();
    const isBannerEnabled = get(mtaOptions, 'offers.household_banner.enabled', false);
    const sortedPolicyByDate = actions.auth.getLatestPolicy();

    if (sortedPolicyByDate && isBannerEnabled) {
      this.setState({
        showBanner: true,
        policyId: sortedPolicyByDate.id,
        customerName: get(auth, 'customer.firstName'),
      });
    }
  }

  private renderPartnerOffers = (hide: boolean = false) => {

    if (hide) {
      return;
    }

    return (
      <OfferCardPanel
        title={<div style={{ fontWeight: 'bold' }}><FaStar/> Explore offers from our partners</div>}
        style={{ marginTop: '40px' }}
      >
        <PartnerOfferCard
          image={require('./img/hotels-1.jpg')}
          contentText={
            <>
              <div>Find and book your new favourite stay.</div>
              <div style={{ marginTop: '20px' }}>Get <b>10% discount</b> on accommodation bookings made through
                Hotels.com,
                <a href={'https://uk.hotels.com/lp/b/couponsTermsAndConditions?campaignId=56697'}
                   target={'_blank'}> Terms & Conditions Apply</a>
              </div>
            </>
          }
          buttonMarginTop={'40px'}
          buttonText={'10% DISCOUNT'}
          redirectUrl={'https://hotels.prf.hn/click/camref:1101l3UmJC/destination:https://uk.hotels.com/lp/b/admiral'}
        />
        <PartnerOfferCard
          image={require('./img/expedia-1.jpg')}
          contentText={
            <>
              <div>Your one-stop travel site for your next dream holiday.</div>
              <div style={{ marginTop: '20px' }}>Get <b>10% discount</b> on accommodation when booking through Expedia.
                <a href={'https://www.expedia.co.uk/lp/b/gbadmiralgrouppub10hotel20240814'} target={'_blank'}> Terms &
                  Conditions Apply</a>
              </div>
            </>
          }
          buttonMarginTop={'40px'}
          buttonText={'10% DISCOUNT'}
          redirectUrl={'https://prf.hn/click/camref:1011l3UnfD/destination:https://expedia.co.uk/lp/b/admiral'}
        />
        <PartnerOfferCard
          image={require('./img/expedia-2.jpg')}
          contentText={
            <>
              <div>Find activities, attractions and fun things to do.</div>
              <div style={{ marginTop: '20px' }}>Get <b>8% discount</b> on experiences when booking through Expedia.
              </div>
              <div><a href={'https://www.expedia.co.uk/lp/b/gbadmiralgrouppub8activities20240814'}
                      target={'_blank'}> Terms
                & Conditions Apply</a>
              </div>
            </>
          }
          buttonMarginTop={'40px'}
          buttonText={'8% DISCOUNT'}
          redirectUrl={'https://prf.hn/click/camref:1011l3UnfD/destination:https://expedia.co.uk/lp/b/admiral'}
        />
      </OfferCardPanel>
    )
  }

  public render() {
    const hide = true;
    return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

      {this.renderPartnerOffers(false)}

      <OfferCardPanel
        title={<div style={{ fontWeight: 'bold' }}><FaMoneyBillWave/> Save more with Admiral</div>}
        style={{ marginTop: '40px' }}
      >
        <AdmiralOfferCard
          image={require('./img/offer_pet.png')}
          titleText={<span style={{ color: '#0045A0' }}>Cover your pets with love</span>}
          contentText={<span
            style={{ color: '#0045A0' }}>With flexible cover and discounts for multi pet.</span>}
          buttonText={'START A PET INSURANCE QUOTE'}
          redirectUrl={'https://www.admiral.com/pet-insurance?media=PITP1'}
        />
        {this.state.showBanner && <AdmiralHouseholdOfferCard
          image={require('./img/offer_household.png')}
          policyId={this.state.policyId}
          customerName={this.state.customerName}
          authActions={this.props.actions.auth}
        />}
        {!hide && <AdmiralOfferCard
          image={require('./img/offer_loan.png')}
          titleText={<span style={{ color: 'white' }}>Personal Loans up to &pound;30,000</span>}
          contentText={<span style={{ color: 'white' }}>Get your personalised quote today, with no impact on your credit score.</span>}
          buttonText={'START A PERSONAL LOAN QUOTE'}
          redirectUrl={'https://money.admiral.com/quote?mediacode=TRAVL'}
        />}
        <AdmiralOfferCard
          image={require('./img/offer_multi_car.png')}
          titleText={<span
            style={{ color: '#0045A0' }}>Make life a little easier with Admiral multi car insurance</span>}
          contentText={<span
            style={{ color: '#0045A0' }}>Click below to see how much you could save with multi car discounts.</span>}
          buttonText={'START A MULTICAR QUOTE'}
          redirectUrl={'https://www.admiral.com/multi-car-insurance?media=MUTP1'}
        />
        <AdmiralOfferCard
          image={require('./img/offer_single_car.png')}
          titleText={<span
            style={{ color: 'white' }}>Trust us - we've been doing car insurance for over 30 years</span>}
          contentText={<span
            style={{ color: 'white' }}>Click below to get your personalised quote.</span>}
          buttonText={'START A CAR QUOTE'}
          redirectUrl={'https://www.admiral.com/car-insurance?media=MITP1'}
        />
        <AdmiralOfferCard
          image={require('./img/offer_refer.png')}
          contentText={
            <span
              style={{ color: 'black' }}>
            <div style={{ fontWeight: 'bold', fontSize: '18px' }}>Start earning with every successful referral</div>
            <div>Sign up to receive your unique referral link. Share this with your friends and family to start earning rewards.</div>
          </span>
          }
          buttonText={'GET MY SHARING LINK'}
          buttonStyle={{ marginTop: '10px' }}
          redirectUrl={'https://www.admiral.com/refer-a-friend'}
          contentStyle={{ marginTop: '185px' }}
          buttonClass={'partner-button'}
        />
      </OfferCardPanel>

    </div>;
  }
}

export default flow([
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        auth: bindActionCreators({ ...authActions }, dispatch),
        mta: bindActionCreators({ ...mtaActions }, dispatch),
      }
    }),
  ),
])(CustomerOffers);
